// Third party
import React from 'react';
import classNames from 'classnames';
import Downshift from 'downshift';
import uniqueId from 'lodash/uniqueId';

// Components
import { Button } from '../../../components/buttons';
import { Tooltip } from '../../../components/tooltips';

// Utils
import { FormattedMessage } from '../../../../utils/i18n';

type Props = {
  dark?: boolean;
  icon?: string;
  className?: string;
  modal: React.ReactNode;
  tooltipText?: string;
  disabled?: boolean;
  isLightVersion?: boolean;
};

const ComparisonTopBarSettingsButton = (props: Props) => {
  const menuId = React.useMemo(() => uniqueId('comparison-settings-options-'), []);

  return (
    <Downshift>
      {({ getMenuProps, isOpen, toggleMenu }) => {
        const { ref: menuRef, ...menuProps } = getMenuProps();
        menuProps.role = 'dialog';

        return (
          <div className="position-relative">
            <Tooltip
              className={classNames({ 'custom-tooltip-v2': props.isLightVersion })}
              disabled={!props.tooltipText}
              message={props.tooltipText}
              place="bottom"
            >
              <div className="tooltip-wrapper">
                <Button
                  icon={props.icon ? props.icon : 'cog'}
                  disabled={props.disabled}
                  onClick={() => toggleMenu()}
                  className={classNames(props.className, 'top-bar-button', { 'is-active': isOpen, legacy: !props.isLightVersion })}
                >
                  <FormattedMessage id="SiteNavigation.Settings" />
                </Button>
              </div>
            </Tooltip>
            <div ref={menuRef} className={classNames('comparison-settings-options', { 'opened d-table': isOpen })} {...menuProps}>
              {props.modal}
            </div>
          </div>
        );
      }}
    </Downshift>
  );
};

export default ComparisonTopBarSettingsButton;
